
import { createSlice } from "@reduxjs/toolkit";
const subjectsSlice = createSlice({
    name: "subject",
    initialState: {
        creatsubject: {
            isFetching: false,
            error: false,
            success: false
        },
        editsubject: {
            isFetching: false,
            error: false,
            success: false
        },
        deletesubject: {
            isFetching: false,
            error: false,
            success: false
        },
        subjects: {
            listsubjects: null,
            isFetching: false,
            error: false,
        }
        
    },
    reducers: {
        deleteSubjectStart: (state) => {
            state.deletesubject.isFetching = true;
        },
        deleteSubjectSuccess: (state) => {
            state.deletesubject.isFetching = false;
            state.deletesubject.error = false;
            state.deletesubject.success = true;
        },
        deleteSubjectFailed: (state) => {
            state.deletesubject.isFetching = false;
            state.deletesubject.error = true;
            state.deletesubject.success = false;
        },
        editSubjectStart: (state) => {
            state.editsubject.isFetching = true;
        },
        editSubjectSuccess: (state) => {
            state.editsubject.isFetching = false;
            state.editsubject.error = false;
            state.editsubject.success = true;
        },
        editSubjectFailed: (state) => {
            state.editsubject.isFetching = false;
            state.editsubject.error = true;
            state.editsubject.success = false;
        },
        createSubjectStart: (state) => {
            state.creatsubject.isFetching = true;
        },
        createSubjectSuccess: (state) => {
            state.creatsubject.isFetching = false;
            state.creatsubject.error = false;
            state.creatsubject.success = true;
        },
        createSubjectFailed: (state) => {
            state.creatsubject.isFetching = false;
            state.creatsubject.error = true;
            state.creatsubject.success = false;
        },
        getsubjectStart: (state) => {
            state.subjects.isFetching = true;
        },
        getsubjectSuccess: (state, action) => {
            state.subjects.isFetching = false;
            state.subjects.listsubjects = action.payload;
            state.subjects.error = false;
        },
        getsubjectFailed: (state) => {
            state.subjects.isFetching = false;
            state.subjects.error = true;
        },
        
    }
});
export const {
    deleteSubjectStart,
    deleteSubjectSuccess,
    deleteSubjectFailed,
    editSubjectStart,
    editSubjectSuccess,
    editSubjectFailed,
    createSubjectStart,
    createSubjectSuccess,
    createSubjectFailed,
    getsubjectStart,
    getsubjectSuccess,
    getsubjectFailed
} = subjectsSlice.actions;
export default subjectsSlice.reducer;
